(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.i18nextV4FormatConverter = {}));
})(this, (function (exports) { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  var FORMS = ['zero', 'one', 'two', 'few', 'many', 'other'];
  var sets = [{
    lngs: ['ach', 'ak', 'am', 'arn', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'],
    toCldr: {
      '': 1,
      _plural: 5
    },
    fromCldr: {
      1: '',
      5: '_plural'
    }
  }, {
    lngs: ['br'],
    toCldr: {
      '': 1,
      _plural: 1
    },
    fromCldr: {
      1: '_plural',
      2: '_plural',
      3: '_plural',
      5: '_plural'
    }
  }, {
    lngs: ['fil', 'tl'],
    toCldr: {
      '': 1,
      _plural: 5
    },
    fromCldr: {
      1: '_plural',
      5: '_plural'
    }
  }, {
    lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur'],
    toCldr: {
      _plural: 5,
      '': 1
    },
    fromCldr: {
      1: '',
      5: '_plural'
    }
  }, {
    lngs: ['se'],
    toCldr: {
      _plural: 2,
      '': 1
    },
    fromCldr: {
      1: '',
      2: '_plural',
      5: '_plural'
    }
  }, {
    lngs: ['yo'],
    toCldr: {
      _plural: 5,
      '': 5
    },
    fromCldr: {
      5: ''
    }
  }, {
    lngs: ['ay', 'bo', 'id', 'ja', 'jbo', 'km', 'ko', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'vi', 'wo', 'zh'],
    toCldr: {
      _0: 5
    },
    fromCldr: {
      5: '_0'
    }
  }, {
    lngs: ['cgg', 'ka', 'ky', 'ug'],
    toCldr: {
      _0: 1
    },
    fromCldr: {
      1: '_0',
      5: '_0'
    }
  }, {
    lngs: ['fa'],
    toCldr: {
      _0: 5
    },
    fromCldr: {
      1: '_0',
      5: '_0'
    }
  }, {
    lngs: ['be', 'cnr', 'ru', 'uk'],
    toCldr: {
      _2: 4,
      _0: 1,
      _1: 3
    },
    fromCldr: {
      1: '_0',
      3: '_1',
      4: '_2'
    }
  }, {
    lngs: ['bs', 'hr', 'sr'],
    toCldr: {
      _2: 5,
      _0: 1,
      _1: 3
    },
    fromCldr: {
      1: '_0',
      3: '_1',
      5: '_2'
    }
  }, {
    lngs: ['dz'],
    toCldr: {
      _2: 5,
      _0: 5,
      _1: 5
    },
    fromCldr: {
      5: '_1'
    }
  }, {
    lngs: ['ar'],
    toCldr: {
      _0: 0,
      _1: 1,
      _2: 2,
      _3: 3,
      _4: 4,
      _5: 5
    },
    fromCldr: {
      0: '_0',
      1: '_1',
      2: '_2',
      3: '_3',
      4: '_4',
      5: '_5'
    }
  }, {
    lngs: ['cs', 'sk'],
    toCldr: {
      _2: 5,
      _0: 1,
      _1: 3
    },
    fromCldr: {
      1: '_0',
      3: '_1',
      5: '_2'
    }
  }, {
    lngs: ['csb', 'pl'],
    toCldr: {
      _2: 4,
      _0: 1,
      _1: 3
    },
    fromCldr: {
      1: '_0',
      3: '_1',
      4: '_2'
    }
  }, {
    lngs: ['cy'],
    toCldr: {
      _2: 4,
      _0: 1,
      _1: 2,
      _3: 5
    },
    fromCldr: {
      0: '_2',
      1: '_0',
      2: '_1',
      3: '_2',
      4: '_2',
      5: '_3'
    }
  }, {
    lngs: ['fr'],
    toCldr: {
      '': 1,
      _plural: 5
    },
    fromCldr: {
      1: '',
      5: '_plural'
    }
  }, {
    lngs: ['ga'],
    toCldr: {
      _2: 3,
      _0: 1,
      _1: 2,
      _3: 4,
      _4: 5
    },
    fromCldr: {
      1: '_0',
      2: '_1',
      3: '_2',
      4: '_3',
      5: '_4'
    }
  }, {
    lngs: ['gd'],
    toCldr: {
      _3: 5,
      _0: 1,
      _1: 2,
      _2: 3
    },
    fromCldr: {
      1: '_0',
      2: '_1',
      3: '_2',
      5: '_3'
    }
  }, {
    lngs: ['is'],
    toCldr: {
      _plural: 5,
      '': 1
    },
    fromCldr: {
      1: '',
      5: '_plural'
    }
  }, {
    lngs: ['jv'],
    toCldr: {
      _0: 5,
      _1: 5
    },
    fromCldr: {
      5: '_1'
    }
  }, {
    lngs: ['kw'],
    toCldr: {
      _3: 5,
      _0: 1,
      _1: 2,
      _2: 5
    },
    fromCldr: {
      1: '_0',
      2: '_1',
      5: '_2'
    }
  }, {
    lngs: ['lt'],
    toCldr: {
      _2: 5,
      _0: 1,
      _1: 3
    },
    fromCldr: {
      1: '_0',
      3: '_1',
      5: '_2'
    }
  }, {
    lngs: ['lv'],
    toCldr: {
      _2: 0,
      _0: 1,
      _1: 0
    },
    fromCldr: {
      0: '_1',
      1: '_0',
      5: '_1'
    }
  }, {
    lngs: ['mk'],
    toCldr: {
      _plural: 5,
      '': 1
    },
    fromCldr: {
      1: '',
      5: '_plural'
    }
  }, {
    lngs: ['mnk'],
    toCldr: {
      _0: 0,
      _1: 1,
      _2: 5
    },
    fromCldr: {
      0: '_0',
      1: '_1',
      5: '_2'
    }
  }, {
    lngs: ['mt'],
    toCldr: {
      _1: 3,
      _0: 1,
      _2: 4,
      _3: 5
    },
    fromCldr: {
      1: '_0',
      3: '_1',
      4: '_2',
      5: '_3'
    }
  }, {
    lngs: ['or'],
    toCldr: {
      _1: 5,
      _0: 1
    },
    fromCldr: {
      1: '_0',
      5: '_1'
    }
  }, {
    lngs: ['ro'],
    toCldr: {
      _1: 3,
      _0: 1,
      _2: 5
    },
    fromCldr: {
      1: '_0',
      3: '_1',
      5: '_2'
    }
  }, {
    lngs: ['sl'],
    toCldr: {
      _0: 5,
      _1: 1,
      _2: 2,
      _3: 3
    },
    fromCldr: {
      1: '_1',
      2: '_2',
      3: '_3',
      5: '_0'
    }
  }, {
    lngs: ['he'],
    toCldr: {
      _3: 5,
      _0: 1,
      _1: 2,
      _2: 4
    },
    fromCldr: {
      1: '_0',
      2: '_1',
      4: '_2',
      5: '_3'
    }
  }];
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        toCldr: set.toCldr,
        fromCldr: set.fromCldr
      };
    });
  });
  function transformKey(code, key) {
    if (key.indexOf('_') < 1) return key;

    var _code$split = code.split(/-|_/),
        _code$split2 = _slicedToArray(_code$split, 1),
        lngOnly = _code$split2[0];

    var rule = rules[code] || rules[lngOnly] || rules.dev;
    if (!rule) return key;
    if (Object.keys(rule.toCldr).length < 1) return key;
    var splitted = key.split('_');
    var oldSuffix = splitted[splitted.length - 1];
    if (isNaN(oldSuffix) && oldSuffix !== 'plural') return key;
    var cldrIndex = rule.toCldr["_".concat(oldSuffix)];
    if (cldrIndex === undefined) return key;
    if (FORMS[cldrIndex] === undefined) return key;
    var newSuffix = FORMS[cldrIndex];
    splitted.pop();
    splitted.push(newSuffix);
    var newKeyName = splitted.join('_');
    return newKeyName;
  }
  function transformNamespace(code, ns) {
    var newNs = {};
    var keys = Object.keys(ns);
    var keysResultOrder = Object.keys(ns);
    var strictSingularFixes = [];

    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];

      if (_typeof(ns[key]) === 'object' && !Array.isArray(ns[key])) {
        newNs[key] = transformNamespace(code, ns[key]);
      } else {
        var newKey = transformKey(code, key);
        newNs[newKey] = ns[key];
        keysResultOrder[keysResultOrder.indexOf(key)] = newKey;

        if (key.endsWith('_plural')) {
          var baseKey = key.substring(0, key.indexOf('_plural'));

          if (ns[baseKey]) {
            strictSingularFixes.push(baseKey);
          }
        }
      }
    }

    strictSingularFixes.forEach(function (singularKey) {
      newNs["".concat(singularKey, "_one")] = ns[singularKey];
      delete newNs[singularKey];
      keysResultOrder[keysResultOrder.indexOf(singularKey)] = "".concat(singularKey, "_one");
    });
    return keysResultOrder.reduce(function (acc, curr) {
      acc[curr] = newNs[curr];
      return acc;
    }, {});
  }

  exports.transformKey = transformKey;
  exports.transformNamespace = transformNamespace;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
